/**
 * Master Sheet Formula: none
 *
 * Formula:
 * =_xlfn.XLOOKUP(S4,'Material + Finish Dropdown IV.'!$A$33:$A$59,'Material + Finish Dropdown IV.'!$B$33:$G$59)
 *
 * Variables:
 * - S4: Surface Finish
 *
 * Notes:
 * - This formula is part of data validation and not an actual formula that we can parse.
 */

import { StandardResult } from '@calculations/utilities/result';
import { StringListMapDataSchema } from '@snap-types/models/auto-configurator-data-set';
import { err, ok } from 'neverthrow';

type Inputs = {
  surfaceFinish: string;
  postFinishOptions: StringListMapDataSchema;
};

export function getPostFinish({
  surfaceFinish,
  postFinishOptions,
}: Inputs): StandardResult<string[]> {
  const postFinish = postFinishOptions[surfaceFinish];

  if (!postFinish) {
    return err({
      message: `Post finish not found for ${surfaceFinish}`,
      context: {
        surfaceFinish,
        postFinishOptions,
      },
    });
  }

  return ok(postFinish);
}
